module.exports = __webpack_public_path__ + "static/media/anquan.5dd57650.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/anquan.png
// module id = 1713
// module chunks = 0 1